import { getSimpleDataSelector } from '@cp-shared-15/frontend-integration';
import { RootState } from 'store/rootReducer';

export const MarketingPreferencesDataSelector = getSimpleDataSelector((state: RootState) => state.marketingPreferences);
